import { View } from "@westpierstudio/luma/mvc";
import { Tween } from "@westpierstudio/luma/createjs";
import { GameServices } from "game/GameServices";
import { Spine } from "pixi-spine";
import { Signal } from "type-signals";
import { addToSpineSlot } from "utils/Misc";
import { BoundedContainer, ImplementBoundedContainer } from "utils/BoundedContainer";
import { AdvancedText } from "@westpierstudio/luma/utils/advancedtext";
import { Container, Text } from "pixi.js";
import { minimumHeightSpecSelector } from "utils/Responsive";

class FGTotalPanelSignals {
    showComplete = new Signal();
    winSummarySound = new Signal();
}

export class FGTotalPanel extends View {
    private panel: Spine & Container;
    private valueText: Text | AdvancedText;
    private totalWinText: Text | AdvancedText;
    signals = new FGTotalPanelSignals();
    valueBounds: BoundedContainer;
    totalWinBounds: BoundedContainer;

    constructor(protected override readonly services: GameServices) {
        super(services);

        const {resources, factory} = services;

        const spec = resources.getSpec(`fgtotalpanel`);

        this.panel = factory.createSpine(spec.panel, this);

        this.valueBounds = new BoundedContainer(spec.valueBounds);
        this.valueText = factory.createText(`16,070,000`, spec.valueText, this.valueBounds);
        this.totalWinText = factory.createText(resources.getMessage(`freeSpinTotalWin`), spec.totalWinText, this);
        this.totalWinBounds = ImplementBoundedContainer(this.totalWinText, spec.totalWinBounds);
        this.totalWinBounds.update();

        addToSpineSlot(this.panel, this.valueBounds, `dynamic-value`);
        addToSpineSlot(this.panel, this.totalWinBounds, `dynamic-total-win`);

        this.reset();

        this.resize();
        services.layout.onResize.add(()=>this.resize());
    }

    show(): void {
        this.visible = true;
        this.panel.state.setAnimation(0, `summary-panel`, false);

        const {resources} = this.services;
        const {waitTime} = resources.getSetting(`fgTotalPanel`);

        Tween.get(this)
        .wait(100)
        .call(() => {
            this.signals.winSummarySound.dispatch();
        });

        Tween.get(this)
        .wait(waitTime)
        .call(() => {
            this.signals.showComplete.dispatch();
        });
    }

    override reset(): void {
        this.visible = false;
    }

    setValueText(valueText: number): void {
        this.valueText.text = this.services.currency.formatCoins(valueText, {group: true});
        this.valueBounds.update();
    }

    skip(): void {
        Tween.removeTweens(this);

        this.signals.showComplete.dispatch();
        this.reset();
    }

    resize() {
        const spec = this.services.resources.getSpec(`fgtotalpanel`);
        const portraitSpec = minimumHeightSpecSelector(this.services, spec.portrait);
        this.services.factory.applySpec(this.panel, portraitSpec);
    }
}